import { GameConstants } from "../../GameConstants";
import { Car } from "./cars/Car";
import { Trunk } from "./trunks/Trunk";
import { Chicken } from "./chickens/Chicken";
import { Ragdoll } from "./chickens/Ragdoll";
import { Feather } from "./Feather";
import { ChickenWaiting } from "./chickens/ChickenWaiting";
import { ChickenManager } from "./chickens/ChickenManager";
import { RoadManager } from "./Roadmanager";
import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";

export class StageContainer extends Phaser.Group {

        public static LANES_PX = [162, 226, 290, 515, 578, 640];
        public static CARS = [GameConstants.CAR_TYPE_1, GameConstants.CAR_TYPE_2, GameConstants.CAR_TYPE_3, GameConstants.CAR_TYPE_4, GameConstants.CAR_TYPE_5, GameConstants.CAR_TYPE_6, , GameConstants.CAR_TYPE_7, GameConstants.CAR_TYPE_8, GameConstants.CAR_TYPE_9, GameConstants.CAR_TYPE_10];
        public static TRUNKS_PY_0 = 0;
        public static TRUNKS_PY_1 = 0;
        public static TRUNKS_VEL_0 = -1;
        public static TRUNKS_VEL_1 = 1.2;

        public static currentInstance: StageContainer;

        public cars: Car[];
        public trunks: Trunk[];
        public chicken: Chicken;
        public ragdolls: Ragdoll[];
        public feather: Feather;

        private debugGraphics: Phaser.Graphics;
        private ragdollsContainer: Phaser.Group;
        private trunksContainer: Phaser.Group;
        private carsAndChickensContainer: Phaser.Group;
        private renderTexture: Phaser.RenderTexture;
        private bloodImage: Phaser.Image;
        private featherParticle: Phaser.Image;

        constructor(game: Phaser.Game) {

            super(game, null, "stage-container");

            StageContainer.currentInstance = this;

            this.ragdolls = [];

            if (GameConstants.SHOW_GUIDES) {
                this.addGuides();
            } else {
                this.debugGraphics = null;
            }

            this.featherParticle = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "feather_1.png");
            this.featherParticle.anchor.set(.5);

            this.renderTexture = new Phaser.RenderTexture(this.game, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
            this.bloodImage = new Phaser.Image(this.game, 0, 0, this.renderTexture);

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
                this.bloodImage.visible = showBlood;
            }
            
            this.add(this.bloodImage);

            this.ragdollsContainer = new Phaser.Group(this.game);
            this.add(this.ragdollsContainer);

            this.trunksContainer = new Phaser.Group(this.game);
            this.add(this.trunksContainer);

            this.carsAndChickensContainer = new Phaser.Group(this.game);
            this.add(this.carsAndChickensContainer);

            this.feather = new Feather(this.game);
            this.carsAndChickensContainer.add(this.feather);

            this.setCars();

            this.setTrunks();

            this.setChickenWaiting();

            this.chicken = new Chicken(this.game, 1);
            this.chicken.x = GameVars.randomDataGenerator.realInRange(10, 90);

            if (!/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {
                this.chicken.y = GameVars.randomDataGenerator.realInRange(100, GameConstants.GAME_HEIGHT - 10);
            } else {
                this.chicken.y = GameVars.randomDataGenerator.realInRange(100, GameConstants.GAME_HEIGHT - 100);
            }

            this.carsAndChickensContainer.add(this.chicken);
        }

        public update(): void {

            super.update();

            GameVars.trunksLine = null;
           
            this.carsAndChickensContainer.sort("y", Phaser.Group.SORT_ASCENDING);

            const cars = this.cars;
        
            if (this.chicken) {

                const chickenSprite = this.chicken.chickenSprite;
                const feather = this.feather.sprite;
                const trunks = this.trunks;

                this.game.physics.arcade.overlap(chickenSprite, cars, this.onChickenCollision, null, this);
                this.game.physics.arcade.overlap(chickenSprite, feather, this.onFeatherCollision, null, this);
                this.game.physics.arcade.overlap(chickenSprite, trunks, this.onTrunksCollision, null, this);

                this.checkFreezeAction();
            }

            for (let i = 0; i < this.ragdolls.length; i++) {

                const ragdoll = this.ragdolls[i];
                const cars = this.cars;

                this.game.physics.arcade.overlap(ragdoll, cars, this.onRagdollCollision, null, this);
            }
        }

        public setChickenWaiting(): void {

            for (let i = 0; i < 3; i++) {
                for (let j = 0; j < 8; j++) {

                    const x = GameVars.randomDataGenerator.realInRange(10 + i * 30, 10 + i * 30 + 20);
                    let y: number;

                    if (!/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {
                        y = GameVars.randomDataGenerator.realInRange(100 + 45 * j, 100 + 45 * j + 20);
                    } else {
                        y = GameVars.randomDataGenerator.realInRange(100 + 30 * j, 100 + 30 * j + 20);
                    }

                    const chickenWaiting = new ChickenWaiting(this.game, x, y, GameConstants.LEFT);
                    const s = GameVars.randomDataGenerator.realInRange(.875, 1);
                    chickenWaiting.scale.set(chickenWaiting.scale.x * s, s);
                    this.carsAndChickensContainer.add(chickenWaiting);

                    ChickenManager.addChicken(chickenWaiting, GameConstants.LEFT);
                }
            }
        }

        public onChickenCollision(sprite1: Phaser.Sprite, sprite2: Phaser.Sprite): void {

            const chicken = <Chicken> sprite1.parent;

            const car = <Car> sprite2;
            car.onChickenHit(chicken.x);

            this.chickenDeathAnimation(chicken.x, chicken.y);
            this.drawHitBlood(car, chicken);

            const ragdoll = new Ragdoll(this.game);
            ragdoll.hit(chicken.x, chicken.y, car);
            this.add(ragdoll);

            this.ragdolls.push(ragdoll);

            RoadManager.onChickenHit();

            this.chicken.kill();
            this.chicken = null;     
            
            this.respawnChicken();

            this.game.camera.shake(0.0025, 75);

            const rand = GameVars.randomDataGenerator.integerInRange(0, 3);
            AudioManager.playSound("splat_" + rand);
        }

        public onFeatherCollision(sprite1: Phaser.Sprite, sprite2: Phaser.Sprite): void {

            this.feather.disable();
            RoadManager.takeFeather();
        }

        public onTrunksCollision(sprite1: Phaser.Sprite, sprite2: Phaser.Sprite): void {

            const trunk = <Trunk> sprite2;

            GameVars.trunksLine = trunk.name;
        }

        public onRagdollCollision(sprite1: Phaser.Sprite, sprite2: Phaser.Sprite): void {

            let ragdoll = <Ragdoll> sprite1;
            let car = <Car> sprite2;

            ragdoll.onCarCollision(car);
        }

        public ragdollStoppedMoving(ragDoll: Ragdoll): void {

            this.ragdollsContainer.add(ragDoll);
        }

        public addBloodDrop(x: number, y: number): void {

            if (GameVars.noBloodMode) {
                return;
            }

            if (x > 340 && x < 470) {
                return;
            }

            const graphics = new Phaser.Graphics(this.game);
            graphics.beginFill(GameConstants.BLOOD_COLOR);
            const bloodDropDiameter = GameVars.randomDataGenerator.integerInRange(2, 7);
            graphics.drawCircle(x, y, bloodDropDiameter);
            graphics.endFill();
            this.renderTexture.render(graphics);
            graphics.destroy();

            if (Math.random() > .8) {

                const feather_x = GameVars.randomDataGenerator.realInRange(x - 3, x + 3);
                const feather_y = GameVars.randomDataGenerator.realInRange(y - 3, y + 3);

                this.featherParticle.frameName = Math.random() > .5 ? "feather_1.png" : "feather_2.png";
                this.featherParticle.angle = GameVars.randomDataGenerator.realInRange(0, 360);
                this.renderTexture.renderXY(this.featherParticle, feather_x, feather_y);
            }
        }

        public addBloodDropStatic(x: number, y: number, index: number): void {

            if (GameVars.noBloodMode) {
                return;
            }

            if (x > 340 && x < 470) {
                return;
            }

            const graphics = new Phaser.Graphics(this.game);
            graphics.beginFill(GameConstants.BLOOD_COLOR);
            let bloodDropDiameter = index;
            graphics.drawEllipse(x, y, bloodDropDiameter * 1.6, bloodDropDiameter);
            graphics.endFill();
            this.renderTexture.render(graphics);
            graphics.destroy();
        }

        public removeRagdoll(ragdoll: Ragdoll): void {

            this.ragdollsContainer.removeChild(ragdoll);
            ragdoll.destroy();

            let index = this.ragdolls.indexOf(ragdoll);
            if (index > -1) {
                this.ragdolls.splice(index, 1);
            }
        }

        public onChickenSaved(): void {

            const savedChicken = new ChickenWaiting(this.game, this.chicken.x, this.chicken.y, GameConstants.RIGHT);
            this.carsAndChickensContainer.add(savedChicken);

            ChickenManager.addChicken(savedChicken, GameConstants.RIGHT);

            this.chicken.destroy();
            this.chicken = null;     
            
            this.respawnChicken();
        }

        public onChickenDrowned(): void {

            const rand = GameVars.randomDataGenerator.integerInRange(0, 3);
            AudioManager.playSound("splash_" + rand);

            this.addDrowningAnimation(this.chicken.x, this.chicken.y, this.chicken.scale.x);

            this.chicken.destroy();
            this.chicken = null; 

            this.respawnChicken();
        }

        private addDrowningAnimation(x: number, y: number, scaleX: number): void {

            const chickenDrowning = new Phaser.Image(this.game, x, y + 20, "texture_atlas_1", "drowning_0001.png");
            chickenDrowning.anchor.set(.5, 1);
            chickenDrowning.scale.x = scaleX;
            this.trunksContainer.addAt(chickenDrowning, 0);

            let chickenDrowning2 = new Phaser.Image(this.game, x, y + 20, "texture_atlas_1", "drowning2_0001.png");
            chickenDrowning2.anchor.set(.5, 1);
            chickenDrowning2.scale.x = scaleX;
            this.trunksContainer.addAt(chickenDrowning2, 0);

            chickenDrowning.animations.add("anim", Phaser.Animation.generateFrameNames("drowning_", 1, 4, ".png", 4));
            chickenDrowning2.animations.add("anim", Phaser.Animation.generateFrameNames("drowning2_", 1, 4, ".png", 4));

            chickenDrowning.play("anim", 30, false, true);
            chickenDrowning2.play("anim", 30, false, true);

        }

        private chickenDeathAnimation(x: number, y: number): void {

            const feathers = new Phaser.Image(this.game, x, y, "texture_atlas_1", "puff2_0001.png");
            feathers.anchor.set(.5, 1);
            this.add(feathers);

            if (Math.random() > .5) {
                feathers.animations.add("anim", Phaser.Animation.generateFrameNames("puff2_", 1, 5, ".png", 4));
            } else {
                feathers.animations.add("anim", Phaser.Animation.generateFrameNames("pufff_", 1, 6, ".png", 4));
            }
           
            feathers.play("anim", 20, false, true);

            this.game.add.tween(feathers)
                .to({ y: feathers.y - 10}, 250, Phaser.Easing.Cubic.Out, true);
        }

        private checkFreezeAction(): void {

            if (!this.chicken) {
                return;
            }

            for (let i = 0; i < this.cars.length; i++) {

                if (this.cars[i].carOnCone) {
                    continue;
                }
                
                if (this.needFreeze(this.chicken.position, this.cars[i].position, i)) {

                    if (!GameVars.freezeAction) {
                        const rand = GameVars.randomDataGenerator.integerInRange(1, 5);
                        AudioManager.playSound("horn" + rand);
                    }

                    if (!GameVars.freezeAction) {
                        RoadManager.freezeAction(true);
                    }
                    return;
                }
            }

            if (GameVars.freezeAction) {
                RoadManager.freezeAction(false);   
            }
        }

        private needFreeze(chicken: Phaser.Point, car: Phaser.Point, i: number): boolean {

            if (chicken.x > car.x - 40 && chicken.x < car.x + 40 ) {
                if (i < 4) {
                    if (chicken.y > car.y && chicken.y < car.y + 70) {
                        return true;
                    }
                } else {
                    if (chicken.y < car.y && chicken.y > car.y - 100) {
                        return true;
                    }
                }
                
            }

            return false;
        }

        private respawnChicken(): void {

            // TODO: setear esta variable en algun manager
            GameVars.riverSide = GameConstants.RIVER_LEFT;

            const waitingChicken = ChickenManager.getWaitingChicken();

            if (waitingChicken !== null) {

                this.chicken = new Chicken(this.game, waitingChicken.scale.y);
                this.chicken.x = waitingChicken.x;
                this.chicken.y = waitingChicken.y;
                
                this.carsAndChickensContainer.add(this.chicken);

                waitingChicken.destroy();

            } else {
                RoadManager.gameOver();
            }
        }

        private drawHitBlood(car: Car, chicken: Chicken): void {

            if (GameVars.noBloodMode) {
                return;
            }

            // para q no pinte sangre en el rio
            if (this.chicken.x > 340 && this.chicken.x < 470) {
                return;
            }
            
            const graphics = new Phaser.Graphics(this.game);
            graphics.beginFill(GameConstants.BLOOD_COLOR);

            const n = car.fastCar ? GameVars.randomDataGenerator.integerInRange(15, 20) : GameVars.randomDataGenerator.integerInRange(8, 12);
            let dy = car.lane < 3 ? 4 : -4;

            for (let i = 0; i < n; i ++) {

                const bloodDrop_x = GameVars.randomDataGenerator.realInRange(-2 * i, 2 * i);
                const bloodDrop_y = i * dy * GameVars.randomDataGenerator.realInRange(1, 1.5); 
                const bloodDropDiameter = GameVars.randomDataGenerator.integerInRange(3, i > n / 2 ? 5 : 9);
                graphics.drawCircle(bloodDrop_x, bloodDrop_y, bloodDropDiameter);
            }
           
            graphics.endFill();

            graphics.scale.y = .25;
            graphics.x = chicken.x;
            graphics.y = chicken.y;
            this.addAt(graphics, 0);

            for (let i = 0; i < 8; i ++) {
                const feather_x = GameVars.randomDataGenerator.realInRange(-2 * i, 2 * i) + chicken.x;
                const feather_y = i * dy * GameVars.randomDataGenerator.realInRange(1, 1.5) + chicken.y; 
                
                this.featherParticle.frameName = Math.random() > .5 ? "feather_1.png" : "feather_2.png";
                this.featherParticle.angle = GameVars.randomDataGenerator.realInRange(0, 360);
                this.renderTexture.renderXY(this.featherParticle, feather_x, feather_y);
            }

            this.game.add.tween(graphics.scale)
                .to({ y: 1}, 150, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function(): void {
                    this.renderTexture.render(graphics);
                    graphics.destroy();
                }, this);
        }

        private addGuides(): void {
            
            this.debugGraphics = new Phaser.Graphics(this.game);
            this.add(this.debugGraphics);

            this.debugGraphics.lineStyle(2, 0x0000FF);

            // la parte izquierda
            for (let i = 0; i < 3; i ++) {

                this.debugGraphics.moveTo(StageContainer.LANES_PX[i], 0);
                this.debugGraphics.lineTo(StageContainer.LANES_PX[i], GameConstants.GAME_HEIGHT);
            }

            // la parte derecha
            this.debugGraphics.lineStyle(2, 0x00FF00);

            for (let i = 0; i < 3; i ++) {
                this.debugGraphics.moveTo(StageContainer.LANES_PX[i + 3], 0);
                this.debugGraphics.lineTo(StageContainer.LANES_PX[i + 3], GameConstants.GAME_HEIGHT);
            }
        }

        private setCars(): void {
            
            this.cars = [];

            let car = new Car(this.game, GameConstants.CAR_TYPE_1, 0);
            car.y = 200;
            this.carsAndChickensContainer.add(car);
            this.cars.push(car);

            car = new Car(this.game, GameConstants.CAR_TYPE_2, 1);
            car.y = 400;
            this.carsAndChickensContainer.add(car);
            this.cars.push(car);

            car = new Car(this.game, GameConstants.CAR_TYPE_8, 2);
            car.y = 300;
            this.carsAndChickensContainer.add(car);
            this.cars.push(car);

            car = new Car(this.game, GameConstants.CAR_TYPE_3, 3);
            car.y = 300;
            this.carsAndChickensContainer.add(car);
            this.cars.push(car);

            car = new Car(this.game, GameConstants.CAR_TYPE_10, 4);
            car.y = 400;
            this.carsAndChickensContainer.add(car);
            this.cars.push(car);

            car = new Car(this.game, GameConstants.CAR_TYPE_4, 5);
            car.y = 250;
            this.carsAndChickensContainer.add(car);
            this.cars.push(car);
        }

        private setTrunks(): void {

            this.trunks = [];

            // lane 0
            let x = GameConstants.GAME_WIDTH / 2 - 25 + 3;
            let y = - 200;

            for (let i = 0; i < 10; i++) {
                let trunk = new Trunk(this.game, x, y, 0);
                this.trunksContainer.add(trunk);
                this.trunks.push(trunk);

                y += GameVars.randomDataGenerator.realInRange(150, 250);
            }

            StageContainer.TRUNKS_PY_1 = y + 200;

            // lane 1
            x = GameConstants.GAME_WIDTH / 2 + 25 + 3;
            y = GameConstants.GAME_HEIGHT + 200;

            for (let i = 0; i < 10; i++) {
                let trunk = new Trunk(this.game, x, y, 1);
                this.trunksContainer.add(trunk);
                this.trunks.push(trunk);

                y -= GameVars.randomDataGenerator.realInRange(150, 250);
            }

            StageContainer.TRUNKS_PY_0 = y - 200;
            
        }
    }
